import React, { useMemo } from 'react'
import {Row, Col} from 'react-bootstrap'
import { useTable, useSortBy, useFilters, useGlobalFilter, usePagination } from 'react-table'

import "../assets/css/components/propertyTable.css"

export default function DataTable(props){

  // const onClicked = (type, info)=>{
  //     props.history.push(`/${type}/${info.original._id}`)
  // }

  const filteredColumns = useMemo(() => 
    props.cols?.filter(col => col.show !== false) || [],
    [props.cols]
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      columns: filteredColumns,
      data: props.data || [],
      initialState: { pageSize: props.data?.length || 10 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  return props.data?.length ? (
    <div style={{width:'100%'}}>
      <Row className="g-0">
        <Col>
          <table {...getTableProps()} className="table table-striped table-hover table-bordered">
            <thead style={{boxShadow: '-4px 9px 7px -7px rgba(0,0,0,0.2)'}}>
              {headerGroups.map(headerGroup => {
                const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps()
                return (
                  <tr key={key} {...headerGroupProps}>
                    {headerGroup.headers.map(column => {
                      const { key, ...columnProps } = column.getHeaderProps(column.getSortByToggleProps())
                      return (
                        <th 
                          key={key} 
                          {...columnProps}
                          style={{
                            borderBottom: 0,
                            fontWeight: 100,
                            textAlign: 'center',
                            padding: '8px'
                          }}
                        >
                          {column.render('Header')}
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? ' 🔽'
                                : ' 🔼'
                              : ''}
                          </span>
                        </th>
                      )
                    })}
                  </tr>
                )
              })}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map(row => {
                prepareRow(row)
                const { key, ...rowProps } = row.getRowProps()
                return (
                  <tr 
                    key={key}
                    {...rowProps}
                    onClick={() => props.onClick && props.onClick(row.original)}
                    style={{ cursor: 'pointer' }}
                  >
                    {row.cells.map(cell => {
                      const { key, ...cellProps } = cell.getCellProps()
                      const isNameOrClient = ['name', 'client'].includes(cell.column.id)
                      return (
                        <td 
                          key={key}
                          {...cellProps}
                          style={{
                            textAlign: isNameOrClient ? 'left' : 'center',
                            paddingLeft: isNameOrClient ? '12px' : undefined
                          }}
                        >
                          {cell.render('Cell')}
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
            </tbody>
          </table>
        </Col>
        {props.children && (
          <Col>
            {props.children}
          </Col>
        )}
      </Row>
    </div>
  ) : null
}
